<template>
  <el-card
    class="box-card po-list-card"
    v-loading="getLoading"
    element-loading-text="Loading POs..."
  >
    <el-row>
      <el-col :span="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="getPagination.page"
          :page-sizes="getCurrentPageSizes"
          :page-size="getPagination.perPage"
          layout="prev, pager, next, sizes"
          :total="getPagination.total"
          class="pull-right"
        ></el-pagination>
      </el-col>
    </el-row>
    <br />
    <el-table
      class="po-list"
      :data="getPoItems"
      border
      :default-sort="{prop: 'updates', order: 'descending'}"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      highlight-current-row
      @header-click="sortBy"
    >
      <div slot="empty">No PO found</div>
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column label="PO#" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <router-link
            :to="{ name: 'po-detail', params: { id: parseInt(scope.row.id, 10) }}"
          >{{ scope.row.poId }}</router-link>
        </template>
      </el-table-column>
      <el-table-column label="Supplier" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.supplierAddress">{{ scope.row.supplierAddress.name }}</span>
          <span v-else style="text-align:center;display:block;">-</span>
        </template>
      </el-table-column>
      <el-table-column label="Hub" v-if="isZeenow" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.customerAddress">{{ scope.row.customerAddress.name }}</span>
          <span v-else style="text-align:center;display:block;">-</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" sortable show-overflow-tooltip width="115">
        <template slot-scope="scope">
          <span
            :class="[ scope.row.status == 'Shipped' ||
          scope.row.status == 'Delivered' ? 'green' : '']"
          >
            {{ scope.row.isInternal && scope.row.status === 'Shipped' ?
            'Delivered' : scope.row.status }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Amount" sortable show-overflow-tooltip width="170">
        <template slot-scope="scope">{{ scope.row.amount | currency }}</template>
      </el-table-column>
      <el-table-column label="Payment" v-if="!isZeenow" sortable show-overflow-tooltip width="118">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.payment.status == 'paid' ? 'success' : 'warning' "
          >{{ scope.row.payment.status == 'paid' ? 'PAID' : 'PENDING' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Updates" width="150">
        <template slot-scope="scope">
          <div
            v-if="scope.row.updates && scope.row.updates.total != -1 && scope.row.updates.total > 0"
          >
            <el-popover ref="popover-info" placement="top-start" width="180" trigger="hover">
              <span>{{ scope.row.updates.tabs.po }} new updates in PO information</span>
            </el-popover>
            <el-popover ref="popover-payments" placement="top-start" width="180" trigger="hover">
              <span>{{ scope.row.updates.tabs.payments }} new updates in PO payments</span>
            </el-popover>
            <el-popover ref="popover-products" placement="top-start" width="180" trigger="hover">
              <span>{{ scope.row.updates.tabs.products }} new updates in PO products</span>
            </el-popover>
            <el-popover ref="popover-comments" placement="top-start" width="180" trigger="hover">
              <span>{{ scope.row.updates.tabs.comments }} new updates in PO comments</span>
            </el-popover>
            <el-popover ref="popover-documents" placement="top-start" width="180" trigger="hover">
              <span>{{ scope.row.updates.tabs.documents }} new updates in PO documents</span>
            </el-popover>
            <span
              v-if="scope.row.updates.tabs.po > 0"
              class="update-wrapper update-wrapper--info"
              v-popover:popover-info
            >{{ scope.row.updates.tabs.po }}</span>
            <span
              v-if="scope.row.updates.tabs.payments > 0"
              class="update-wrapper update-wrapper--payments"
              v-popover:popover-payments
            >{{ scope.row.updates.tabs.payments }}</span>
            <span
              v-if="scope.row.updates.tabs.products > 0"
              class="update-wrapper update-wrapper--products"
              v-popover:popover-products
            >{{ scope.row.updates.tabs.products }}</span>
            <span
              v-if="scope.row.updates.tabs.comments > 0"
              class="update-wrapper update-wrapper--comments"
              v-popover:popover-comments
            >{{ scope.row.updates.tabs.comments }}</span>
            <span
              v-if="scope.row.updates.tabs.documents > 0"
              class="update-wrapper update-wrapper--documents"
              v-popover:popover-documents
            >{{ scope.row.updates.tabs.documents }}</span>
          </div>
          <div
            v-else-if="scope.row.updates && scope.row.updates.total == -1"
            style="text-align:center;"
          >
            <el-tag type="primary">NEW</el-tag>
          </div>
          <div v-else style="text-align:center;">-</div>
        </template>
      </el-table-column>
      <el-table-column label="Created" sortable show-overflow-tooltip width="120">
        <template slot-scope="scope">
          {{ dateTimezoneChina(scope.row.created, true) }}
          ({{ dateTimezoneUser(scope.row.created) }})
        </template>
      </el-table-column>
      <el-table-column label="Last Activity" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.lastActivity.user }} -
          {{ dateTimezoneChina(scope.row.lastActivity.date, true) }}
          ({{ dateTimezoneUser(scope.row.lastActivity.date) }})
        </template>
      </el-table-column>
    </el-table>
    <br />
    <el-row>
      <el-col :span="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="getPagination.page"
          :page-sizes="getCurrentPageSizes"
          :page-size="getPagination.perPage"
          layout="prev, pager, next, sizes"
          :total="getPagination.total"
          class="pull-right"
        ></el-pagination>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getDateTimezoneUser,
  getDateTimezoneChina
} from "@/helpers/user-timezone";

export default {
  data() {
    return {
      itemsSelected: [],
      itemsSelectedId: [],
      allSelected: false,
      poItems: [],
      order: false,
      orderKey: "",
      currentRow: null
    };
  },
  computed: {
    ...mapGetters({
      getPoItems: "getPoItems",
      getPagination: "getPagination",
      getLoading: "getLoading",
      isZeenow: "isZeenow"
    }),
    getCurrentPageSizes() {
      return [10, 25, 50, 100];
    }
  },
  methods: {
    dateTimezoneUser(date) {
      return getDateTimezoneUser(date);
    },
    dateTimezoneChina(date, showTime) {
      return getDateTimezoneChina(date, showTime);
    },
    tableRowClassName(row) {
      if (row.isNew) {
        return "positive-row";
      }
      return "";
    },
    handleSelectionChange(val) {
      this.itemsSelected = val;
      this.itemsSelectedId = [];
      for (let i = 0; i < this.itemsSelected.length; i += 1) {
        this.itemsSelectedId.push(this.itemsSelected[i].id);
      }
      this.setPOSelected();
    },
    sortBy(column) {
      if (typeof column.label !== "undefined" && column.label !== "PO#") {
        let key = "";
        let orderBy = "";
        switch (column.label) {
          case "ID":
            key = "id";
            break;
          case "Status":
            key = "status";
            break;
          case "Amount":
            key = "amount";
            break;
          case "Payment":
            key = "paymentStatus";
            break;
          case "Created":
            key = "created";
            break;
          default:
            break;
        }

        if (!this.order) {
          orderBy = `&o=${key}`;
        } else {
          orderBy = `&o=-${key}`;
        }
        if (key !== "") {
          this.orderKey = key;
          this.order = !this.order;
          this.$store.dispatch("updateOrderBy", orderBy);
          this.$store.dispatch("getSearchedPOData");
        }
      }
    },
    setPOSelected() {
      return this.$store.dispatch("setPOSelected", this.itemsSelectedId);
    },
    selectAll() {
      this.itemsSelected = [];
      if (!this.allSelected) {
        for (let i = 0; i < this.getPoItems.length; i += 1) {
          this.itemsSelected.push(this.getPoItems[i].id);
        }
        this.setPOSelected();
        this.allSelected = true;
      } else {
        this.itemsSelected = [];
        this.setPOSelected();
        this.allSelected = false;
      }
    },
    handleSizeChange(val) {
      if (val !== this.getPagination.perPage) {
        const paginationObj = {};
        paginationObj.perPage = val;
        paginationObj.page = this.getPagination.page;
        this.$store.dispatch("updatePagination", paginationObj);
        this.$store.dispatch("getSearchedPOData");
      }
    },
    handleCurrentChange(val) {
      if (val !== this.getPagination.page) {
        const paginationObj = {};
        paginationObj.perPage = this.getPagination.perPage;
        paginationObj.page = val;
        this.currentPage = val;
        this.$store.dispatch("updatePagination", paginationObj);
        this.$store.dispatch("getSearchedPOData", true);
      }
    }
  }
};
</script>
<style lang="scss">
.el-table .info-row {
  background: #c9e5f5;
}

.el-table .positive-row {
  background: #24c5a7;
}
[v-cloak] {
  visibility: hidden;
}
.pointer {
  cursor: pointer;
}
.has-ordered {
  cursor: pointer;
}
.el-upload,
.el-upload-dragger {
  width: 100% !important;
}
.el-upload__input {
  display: none !important;
}
.el-pager li.active {
  background-color: rgba(52, 73, 94, 0.94);
  border-color: rgba(52, 73, 94, 0.94);
  color: #fff;
}
.table-responsive {
  width: 100%;
}
.po-list-card {
  .el-card__body {
    flex-direction: column;
  }
}
.el-table th,
.el-table th > .cell {
  cursor: pointer;
}
.cell a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/partials/PoList.vue